import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthStrategy, authActions } from '@content-platform/web-angular-shared-util-auth';
import { Store } from '@ngrx/store';
import { catchError, of, from, switchMap, Subject, Subscription, tap } from 'rxjs';
import { Environments, Configuration } from '@content-platform/web-angular-shared-util-configuration';
import { ApplicationApiConstants } from '@content-platform/web-angular-shared-data-access-application-api';
import { WebAngularSharedDataAccessFeatureFlagApisService } from '@content-platform/web-angular-shared-data-access-feature-flag-api';
import { encryptString } from '../utils/aes-encryption.util';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@ngrx/store";
import * as i3 from "@content-platform/web-angular-shared-data-access-feature-flag-api";
export class TcpUserResolver {
    constructor(http, store, featureFlagSvc) {
        this.http = http;
        this.store = store;
        this.featureFlagSvc = featureFlagSvc;
        this.nodeDataS = new Subject();
        this.nodeData$ = this.nodeDataS.asObservable();
        this.subs = new Subscription();
    }
    loadUserDataWithToken(email, token) {
        const activeAppName = ApplicationApiConstants.activeAppName;
        console.log('🚀---- appName ----', activeAppName);
        this.subs.add(this.featureFlagSvc.getFlagAsync("enable-auth-helper-cdk").pipe(catchError(() => of(false)), switchMap((enable) => {
            const urlString = enable
                ? "authHelperUserTokenCdkApi"
                : "authHelperUserTokenApi";
            console.log(":rocket:----Get auth helper user token  api urlkey----", urlString);
            return from(encryptString(email)).pipe(switchMap((encryptedPayload) => {
                const encryptedEmail = JSON.stringify(encryptedPayload);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return this.http.get(Environments.getUrl(urlString), {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: { email: encryptedEmail, app: Configuration.getActiveAppName() },
                });
            }));
        }), tap((userData) => {
            console.log('🚀---- userData received ----', userData);
            this.onUserDataReceived(userData);
        })).subscribe());
    }
    setOidByEmail(email, oid, token) {
        return this.featureFlagSvc
            .getFlagAsync("enable-auth-helper-cdk")
            .pipe(catchError(() => 
        // does not exist
        of(false)), switchMap((enable) => {
            const urlString = enable ? "authHelperSetUsersOidCdkApi" : "authHelperSetUsersOidApi";
            return this.http
                .post(Environments.getUrl(urlString), {
                email,
                oid
            }, {
                headers: new HttpHeaders({
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token.accessToken}`
                })
            })
                .pipe(tap(() => console.log(":rocket:---- users oid set into db ----")));
        }))
            .subscribe();
    }
    checkIfUserIsInternal(email) {
        email = email.toLowerCase();
        if (email.indexOf('@viacom.com') > -1 ||
            email.indexOf('@cbs.com') > -1 ||
            email.indexOf('@paramount.com') > -1 ||
            email.indexOf('@viacomcbs.com') > -1 ||
            email.indexOf('@showtime.net') > -1 ||
            email.indexOf('@showtime.com') > -1 ||
            email.indexOf('@mtvstaff.com') > -1 ||
            email.indexOf('@viacom345.com') > -1 ||
            email.indexOf('@sho.com') > -1) {
            return of({
                "userType": "Member"
            });
        }
        else {
            return of({
                "userType": "Non-member"
            });
        }
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    // reuse old auth lib to substitute user and token
    onUserDataReceived(data) {
        this.nodeDataS.next(data);
        const user = {
            userName: data.mail,
            profile: {
                oid: data.id,
                displayName: data.displayName,
                firstName: data.givenName,
                lastName: data.surname,
                mail: data.mail,
                city: data.city,
                companyName: data.companyName,
                country: data.country,
                objectId: data.id,
                permissionToken: data.userAccessToken,
                graphToken: data.graphToken
            }
        };
        // dispatch ad action to substitute user in store
        this.store.dispatch(new authActions.LoginSuccess(user));
        this.store.dispatch(new authActions.SetAuthenticationStrategy(AuthStrategy.OKTA));
    }
    static { this.ɵfac = function TcpUserResolver_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TcpUserResolver)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i3.WebAngularSharedDataAccessFeatureFlagApisService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TcpUserResolver, factory: TcpUserResolver.ɵfac }); }
}
//# sourceMappingURL=tcp-user-resolver.js.map